import EvaluateResponse from "../../EvaluateResponse"
import Evaluation from "../../Evaluation"
import { EvaluatorContext } from "../../evaluator/Evaluator"
import Workspace from "../../../workspace/Workspace"
import { HackleUser } from "../../../model/model"
import RemoteConfigEvaluation from "./RemoteConfigEvaluation"
import RemoteConfigEvaluateResult from "./RemoteConfigEvaluateResult"
import RemoteConfigEvaluateRequest from "./RemoteConfigEvaluateRequest"

export default class RemoteConfigEvaluateResponse implements EvaluateResponse {
  constructor(
    readonly user: HackleUser,
    readonly workspace: Workspace,
    readonly evaluation: RemoteConfigEvaluation,
    readonly references: Evaluation[]
  ) {}

  static of(
    request: RemoteConfigEvaluateRequest,
    context: EvaluatorContext,
    result: RemoteConfigEvaluateResult
  ): RemoteConfigEvaluateResponse {
    const evaluation = new RemoteConfigEvaluation(request.entity, result)
    return new RemoteConfigEvaluateResponse(request.user, request.workspace, evaluation, context.references)
  }
}
